module.exports = __webpack_public_path__ + "static/media/bet.2cb9b321.jpg";